module.exports = __webpack_public_path__ + "static/img/one.38350a50.png";